import { render, staticRenderFns } from "./SizeColPreview.vue?vue&type=template&id=5cd5213e&"
import script from "./SizeColPreview.vue?vue&type=script&lang=js&"
export * from "./SizeColPreview.vue?vue&type=script&lang=js&"
import style0 from "./SizeColPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports